import {
  useMutation,
  UseMutationResult,
  useQuery,
} from "@tanstack/react-query";
import { challenges } from "../products/challenges";
import {
  challengeByIdInterface,
  challengesDataInterface,
  ChallengesInterface,
  DeleteParams,
  UserChallengesInterface,
} from "../types/types";
export function useCreateChallenges(): UseMutationResult<
  any,
  unknown,
  ChallengesInterface,
  unknown
> {
  return useMutation({
    mutationFn: (body: ChallengesInterface) =>
      challenges.createChallenges(body),
  });
}

export function useGetChallenges(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<challengesDataInterface>({
      queryKey: ["getchallengesData"],
      queryFn: () => challenges.GetChallengesData(option),
    });

  return {
    challengesData: data,
    challengesLoading: isLoading,
    error,
    status,
    isSuccess,
    challengesRefetch: refetch,
  };
}
export function useGetUserChallenges(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<UserChallengesInterface>({
      queryKey: ["getUserChallengesData"],
      queryFn: () => challenges.GetUserChallengesData(option),
    });

  return {
    challengesData: data,
    challengesLoading: isLoading,
    error,
    status,
    isSuccess,
    challengesRefetch: refetch,
  };
}
export function useGetChallengeById(id?: number) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<challengeByIdInterface>({
      queryKey: ["getChallengeByIdInterface"],
      queryFn: () => challenges.GetChallengeById(id),
    });

  return {
    challengesData: data,
    challengesLoading: isLoading,
    error,
    status,
    isSuccess,
    challengesRefetch: refetch,
  };
}
export function useUpdateChallenges(
  id: number
): UseMutationResult<any, unknown, ChallengesInterface, unknown> {
  return useMutation({
    mutationFn: (body: ChallengesInterface) =>
      challenges.UpdateChallenge(body, id),
  });
}
export function useDeleteChallenge(): UseMutationResult<
  any,
  unknown,
  DeleteParams,
  unknown
> {
  return useMutation({
    mutationFn: (body: DeleteParams) => challenges.deleteChallenge(body.id),
  });
}
